import ModalContainer from "../../../Components/UiKits/Modal/ModalContainer";

const Modal = () => {
  return <ModalContainer />;
};

export default Modal;
